import { SETTINGGENERAL, SETTINGANMS, SETTINGREDUNDANCY } from "../types/index";
const generalState = {
  generaldata: []
};
const settingGeneralReducer = (state = generalState, action) => {
  switch (action.type) {
    case SETTINGGENERAL:
      return {
        generaldata: action.settingGeneralData
      };
    default:
      return state;
  }
};
const anmsState = {
  anmsdata: []
};
const settingAnmsReducer = (state = anmsState, action) => {
  switch (action.type) {
    case SETTINGANMS:
      return {
        anmsdata: action.settingAnmsData
      };
    default:
      return state;
  }
};
const redundancyState = {
  redundancydata: []
};
const settingRedundancyReducer = (state = redundancyState, action) => {
  switch (action.type) {
    case SETTINGREDUNDANCY:
      return {
        redundancydata: action.settingRedundancyData
      };
    default:
      return state;
  }
};

export { settingGeneralReducer, settingAnmsReducer, settingRedundancyReducer };
